import { AuthSecurity } from '../../models/auth/auth-security';

export class SignInAuth {
  readonly type = 'SIGNIN_AUTH';
  constructor(public auth: AuthSecurity) {}
}

export class SignInHash {
  readonly type = 'SIGNIN_HASH';
  constructor(public hash: string) {}
}

export class SignOutAuth {
  readonly type = 'SIGNOUT_AUTH';
  constructor() {}
}

export class UpdateUserId {
  readonly type = 'UPDATE_USERID';
  constructor(public auth: AuthSecurity) {}
}

export type Actions = SignInAuth | SignOutAuth | SignInHash | UpdateUserId;
